module.exports = __webpack_public_path__ + "static/images/containers/Journal/components/ReservesHistory/images/reserve_active.48871730.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Journal/components/ReservesHistory/images/reserve_active.png
// module id = 3106
// module chunks = 11